export const AssetType = {
  LOGOIMAGE: 1,
  COVERIMAGE: 2,
  VIDEO: 3
};
